import { render } from "./ChartDetails.vue?vue&type=template&id=3754e20a&scoped=true"
import script from "./ChartDetails.vue?vue&type=script&lang=ts"
export * from "./ChartDetails.vue?vue&type=script&lang=ts"

import "./ChartDetails.vue?vue&type=style&index=0&id=3754e20a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3754e20a"

export default script